import $ from "jquery";

/**
 * Simplified Object.assign ponyfill
 * @param target
 * @returns {*}
 */
export function assign(target) {
  let i, k, obj;

  if(!target) target = {};

  for(i = 1; i < arguments.length; i++) {
    obj = arguments[i];
    if(!obj) continue;
    for(k in obj) if(obj.hasOwnProperty(k)) target[k] = obj[k];
  }

  return target;
}

export function throttle(fn) {
  let args, thisArg;
  let scheduled = false;

  function callback() {
    fn.apply(thisArg, args);
    scheduled = false;
  }

  return function throttled() {
    args = [];
    for(let i = 0; i < arguments.length; i++) args.push(arguments[i]);
    thisArg = this;
    if(!scheduled) {
      requestAnimationFrame(callback);
      scheduled = true;
    }
  }
}

export function addClass(el, className) { $(el).addClass(className); }
export function removeClass(el, className) { $(el).removeClass(className); }
export function toggleClass(el, className, state) { $(el).toggleClass(className, state); }
